<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Public Policy Society</h3></header>
            <img src="assets/img/public_policy_society.jpg">
            <hr>
            <p>
              The Public Policy Society consists of the students who follow Special degrees in Political Science. This Society aims to enhance the students’ capacities in application of theoretical knowledge into practice. The Society intends to develop analytical skills through encouraging students towards conducting field researches, organizing events such as debates, discussions and public talks and showing films and dramas related to current social and political trends.
            </p>
            <hr>
            <h4>Objectives</h4>
            <ul class="element-framed">
              <li>To enhance the students’ analytical capacities as well as the theoretical and conceptual knowledge.</li>
              <li>To develop critical knowledge of the students on current issues and discourses pertaining to the real politics.</li>
              <li>To encourage a rich political science and public policy research culture among students.</li>
            </ul>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Office Bearers</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Advising Committee</b>
                    <figure class="professor-description">
                      Mr. I.R. Priyantha - Senior Lecturer
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>President</b>
                    <figure class="professor-description">H. W.S.S. Wijepala</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">K.P.C. Dilhani</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice President</b>
                    <figure class="professor-description">N.A.S.S. Gunarathna</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Vice Secretary</b>
                    <figure class="professor-description">K.K.N. Kaushalya</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Treasurer</b>
                    <figure class="professor-description">Dr. N. Ariyarathna - Senior Lecturer</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Treasurer</b>
                    <figure class="professor-description">A.M.I.C. Kumari</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Senior Editor</b>
                    <figure class="professor-description">Mr. E.G. Wijesiri - Senior Lecturer</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Junior Editor</b>
                    <figure class="professor-description">W. Dhammarathna Thero</figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Committee Members</b>
                    <figure class="professor-description">
                      K.P.A.I. Anuruddha (Second Year)<br>
                      A.M.P. Jayamali (Third Year)<br>
                      S.M.S.S. Dilrukshi (Fourth Year)<br>
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
